import axiosConfig from "./axiosConfig";
import { OutreachDraftResponse } from "./postOutreachDraft";

// Load the latest saved turn of an existing outreach thread WITHOUT drafting (no AI
// call). Opening a contact that already has a thread uses this so the saved draft shows,
// rather than spending a fresh draft and starting a duplicate thread. Same response shape
// as postOutreachDraft, so the modal renders it identically.
const getOutreachLatestTurn = async (
  authToken: string,
  leadId: string,
  outreachMessageId: string
): Promise<OutreachDraftResponse> => {
  const { data } = await axiosConfig.get(
    `/leads/${leadId}/outreach/${outreachMessageId}/latest`,
    { headers: { Authorization: `Bearer ${authToken}` } }
  );
  return data;
};

export default getOutreachLatestTurn;
